import { render, staticRenderFns } from "./WhatsAppPhone.vue?vue&type=template&id=5772dc7c&scoped=true"
import script from "./WhatsAppPhone.vue?vue&type=script&lang=js"
export * from "./WhatsAppPhone.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppPhone.vue?vue&type=style&index=0&id=5772dc7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5772dc7c",
  null
  
)

export default component.exports